import React from "react";
import { Box, SimpleGrid, Text, Flex, Icon, Badge, Wrap, WrapItem } from "@chakra-ui/react";
import {
  MdArticle,
  MdEdit,
  MdArchive,
  MdVisibility,
  MdForum,
} from "react-icons/md";
import { useTranslation } from "react-i18next";
import { GOLD_BORDER, GOLD_TEXT, GOLD_LIGHT } from "constants/brandColors";

const StatCard = ({ icon, label, value }) => (
  <Box bg="white" borderRadius="xl" p={5} display="flex" alignItems="center" boxShadow="md" border="1px solid" borderColor={GOLD_LIGHT}>
    <Box w="52px" h="52px" display="flex" alignItems="center" justifyContent="center" bg={GOLD_BORDER} borderRadius="full" me={4}>
      <Icon as={icon} w="26px" h="26px" color="white" />
    </Box>
    <Box>
      <Text fontSize="xl" fontWeight="bold">{value ?? 0}</Text>
      <Text fontSize="sm" color="gray.500">{label}</Text>
    </Box>
  </Box>
);

// `overview` is /reports/overview's data: { newsByStatus, totalViews,
// activeBotTargets, dispatchesByStatus }. Status keys on News are a fixed
// enum (DRAFT/PUBLISHED/ARCHIVED) so those get dedicated cards; dispatch
// status is a free-form string column on the backend (no enum), so those
// render as a dynamic badge row instead of assuming specific values.
export default function ReportStatCards({ overview }) {
  const { t } = useTranslation();
  const newsByStatus = overview?.newsByStatus || {};
  const dispatchesByStatus = overview?.dispatchesByStatus || {};
  const dispatchEntries = Object.entries(dispatchesByStatus);

  return (
    <Box mb={6}>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3, "2xl": 5 }} gap="20px" mb="16px">
        <StatCard icon={MdArticle} label={t("Published")} value={newsByStatus.PUBLISHED} />
        <StatCard icon={MdEdit} label={t("Draft")} value={newsByStatus.DRAFT} />
        <StatCard icon={MdArchive} label={t("Archived")} value={newsByStatus.ARCHIVED} />
        <StatCard icon={MdVisibility} label={t("Total Views")} value={overview?.totalViews} />
        <StatCard icon={MdForum} label={t("Active Bot Targets")} value={overview?.activeBotTargets} />
      </SimpleGrid>

      {dispatchEntries.length > 0 && (
        <Flex align="center" gap={3} wrap="wrap">
          <Text fontSize="sm" fontWeight="600" color={GOLD_TEXT}>
            {t("Broadcast dispatches (selected range)")}:
          </Text>
          <Wrap>
            {dispatchEntries.map(([status, count]) => (
              <WrapItem key={status}>
                <Badge px={2} py={1} borderRadius="md" bg={GOLD_LIGHT} color={GOLD_TEXT}>
                  {status}: {count}
                </Badge>
              </WrapItem>
            ))}
          </Wrap>
        </Flex>
      )}
    </Box>
  );
}
